<template>
  <div style="min-width: 1400px" class="wrapper">
    <HomeHeader> </HomeHeader>
    <TopicCongress></TopicCongress>
    <HomeFooter> </HomeFooter>
  </div>
</template>

<script>
import HomeHeader from "../components/home/HomeHeader";
import HomeFooter from "../components/home/HomeFooter";
import TopicCongress from "../components/topicCongress/TopicCongress";
export default {
  components: {
    HomeHeader,
    HomeFooter,
    TopicCongress,
  },
};
</script>

<style lang="scss" scoped>

</style>